<template>
    <div>
        <fluke-card>
            <header v-if="permission.write">
                <div class="title">Editar Página</div>
                <div class="description">Edite as informações da página</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Página</div>
                <div class="description">Alterações desabilitadas para este perfil</div>
            </header>
            <main>
                <f-mh module_title="Top Banner" class="active">
                    <top-banner ref="bannerTop" />
                </f-mh>

                <core-content />

                <page-modules ref="modules" />
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit" v-if="permission.write">Salvar</fluke-button>
            </footer>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Página</a>
        </div>
        <global-popup ref="remove" title="Remover">Deseja remover a página?</global-popup>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import draggable from "vuedraggable";

import Card from '../../components/Main/Content/Card/Card';
import ModuleHolder from '../../components/Main/Content/ModuleHolder/ModuleHolder';
import Button from '../../components/Main/Content/Button/Button';
import Editor from '../../components/Main/Content/Editor/Editor';
import ImageUploader from '../../components/Main/Content/ImageUploader/ImageUploader';
import BigSlider from '../../components/Main/Content/BigSlider/BigSlider';
import LeftSlider from '../../components/Main/Content/LeftSlider/LeftSlider';

import permission from '../../mixins/permissions';

// PARTS
import topBanner from './parts/01_topBanner';
import coreContent from './parts/02_core';
import pageModules from './parts/03_modules';

export default {
    mixins: [ permission ],
    components: {
        // PARTS
        topBanner,
        coreContent,
        pageModules,

        // OLD
        'fluke-card': Card,
        'fluke-button': Button,
        'fluke-editor': Editor,
        'fluke-imageuploader': ImageUploader,
        'fluke-bigslider': BigSlider,
        'f-mh': ModuleHolder,
        LeftSlider,

    },
    data: function() {
        return {
            modulesListArr: [
                {
                    module: 'InfoBlock',
                    module_name: 'show_infoblocks',
                    title: "Blocos Informativos",
                    content: '',
                    active: false
                },
                {
                    module: 'InfoTheysay',
                    module_name: 'show_theysay',
                    title: "O que as pessoas dizem",
                    content: '',
                    active: false
                },
                {
                    module: 'InfoVant',
                    module_name: 'show_advantages',
                    title: "Vantagens",
                    content: '',
                    active: false
                },
                {
                    module: 'InfoWall',
                    module_name: 'show_imageswall',
                    title: "Divisória de imagens",
                    content: '',
                    active: false
                },
                {
                    module: 'InfoBig',
                    module_name: 'show_bigtitle',
                    title: 'Título grande',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoContact',
                    module_name: 'show_contact',
                    title: 'Contato',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoAux',
                    module_name: 'show_auxcontent',
                    title: 'Conteúdo auxiliar',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoRight',
                    module_name: 'show_rightcontent',
                    title: 'Conteúdo à direita',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoCourses',
                    module_name: 'show_courses',
                    title: 'Cursos',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoForm',
                    module_name: 'show_form',
                    title: 'Formulário',
                    content: '',
                    active: false
                },
                {
                    module: 'InfoSocial',
                    module_name: 'show_social',
                    title: 'Redes Sociais',
                    content: '',
                    active: false
                },
                {
                    module: false,
                    module_name: 'show_blog',
                    title: 'Blog posts',
                    content: '',
                    active: false
                },
                {
                    module: false,
                    module_name: 'show_news',
                    title: 'Newsletter',
                    content: '',
                    active: false
                },
                {
                    module: false,
                    module_name: 'show_events',
                    title: 'Próximos Eventos',
                    content: '',
                    active: false
                }
            ],
            id: null,
            title: '',
            link: '',
            img: '',
            left_slider: '',
            content: '',
            keyer: 0,
            banner_top: 'slider',
            sliderkey: '',
            reload: 1,
            meta_tags: '',
            meta_description: '',
            permission: {
                read: false,
				write: false
            },
            modules: []
        }
    },
    async created(){
        this.$store.commit('set_currentMenu', 'pages' );
        await this.getData();
        this.permission = this.getUserPagePermission('pages');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    // updated: function() {
    //     this.mountModules();
    // },
    methods: {
        async getData(){
            this.id = this.$route.params.id;
            const result = await axios.get(
                this.$myServerAddresses.pages + 'pages/' + this.id,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$store.commit('set_page', result.data );

            return;
        },
        submit: async function( reload ) {
            // var modules = this.getModulesContentFromComponents();
            this.$refs.bannerTop.updateStoreImg();
            this.$refs.modules.setModulesData();

            // return;
            const result = await axios.put(
				this.$myServerAddresses.pages + 'pages',
				{
                    id: this.id,
                    title: this.$store.state.page.title,
                    link: this.$store.state.page.link,
                    img: this.$store.state.page.img,
                    content: this.$store.state.page.content,
                    modules: this.$store.state.page.modules,
                    left_slider: this.$store.state.page.left_slider,
                    module_list: '',
                    meta_description: this.$store.state.page.meta_description,
                    meta_tags: this.$store.state.page.meta_tags
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            if( reload === true )
            {
                this.$router.push({ name: 'pages-edit', params: {
                    id: this.id
                } });
            } else {
                this.$router.push({ name: 'pages' });
            }

        },
        remove: async function () {
            this.$refs.remove
                .confirm()
                .then(()=>{
                    axios.delete(
                        this.$myServerAddresses.pages + 'pages/' + this.id,
                        {
                            headers: {
                                'X-Fluke': this.$cookies.get('token')
                            }
                        }
                    )
                    .then(()=>{
                        this.$router.push({ name: 'pages' });
                    });
                });
        },
        cancel: function() {
            this.$router.push({ name: 'pages' });
        }
    }
}
</script>

<style lang="scss">
#mh_wrapper_sort {
    position: relative;
}
.ui-sortable-placeholder {
    background-color:#FEC402 !important;
    visibility: visible !important;
    height: 26px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 5px 5px 5px 33px;
}
.mh_wrapper {

    user-select: none;

    .mh_header,
    .mh_footer {
        background-color: #eeeeee;
        cursor: pointer;
    }
    .mh_content
    {
        max-height: 0;
        overflow: hidden;
        transition: all 1.5s;
    }
    .mh_header {
        padding: 5px 5px 5px 33px;
        margin-bottom: 10px;
        position: relative;

        i.mh_right {
            position: absolute;
            right: 3px;
            top: 1px;
            transform: rotate(-90deg);
            transition: transform 0.5s;
        }

        i.mh_left {
            position: absolute;
            top: 1px;
            left: 3px;
            color: #bbbbbb;
        }
    }
    .mh_footer {
        text-align: right;
        margin: 0;
        padding-right: 5px;
        transition: all 0.5s;
        max-height: 0;
        overflow: hidden;

    }

    &.active {
        .mh_header {
            i.mh_right {
                transform: rotate(0deg);
            }
        }
        .mh_content {
            max-height: 2000px;
        }
        .mh_footer {
            margin: 10px 0;
            max-height: 100px;
        }
    }
}
</style>
